import TYPES from '../../action-types';

/**
 * Remove keyword from assets immediately
 * @param {string[]} ids
 * @param {string} keywordsIds
 */
export const detachedKeyword = (ids, keywordsIds, userId) => (dispatch) => {
  dispatch({
    type: TYPES.ASSETS.DETACH_KEYWORDS.COMPLETE,
    payload: {
      ids,
      keywordsIds,
      notify: true,
      userId,
    },
  });
};

export default detachedKeyword;
